import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WarrantyActivationFormService } from '@app/features/warranties/activate-warranty-process/steps/warranty-activation-form.service';
import { WarrantyActivationMethod } from '@app/shared/enums/WarrantyActivationMethod.enum';

@Component({
    selector: 'app-activation-method',
    templateUrl: './activation-method.component.html',
    styleUrl: './activation-method.component.scss',
    host: {
        class: 'app-activation-method'
    },
    standalone: false
})
export class StepActivationMethodComponent implements OnInit {

  @Output() stepSaved = new EventEmitter<void>();

  warrantyActivationMethod = WarrantyActivationMethod;
  selectedDefaultActivation = this.warrantyActivationMethod.SERIAL_NUMBER;

  activationMethodFormGroup: FormGroup = this.fb.group({
    activationMethod: [this.selectedDefaultActivation, [Validators.required]]
  });

  constructor(
    private fb: FormBuilder,
    public warrantyActivationFormService: WarrantyActivationFormService) { }

  ngOnInit() {
    this.initFormStep();
    this.activationMethodFormGroup.controls['activationMethod'].valueChanges.subscribe(value => {
      this.warrantyActivationFormService.setStepData('activationMethod', { activationMethod: value });
    });

  }

  initFormStep() {
    const stepData = this.warrantyActivationFormService.getStepData('activationMethod');
    if (stepData) {
      this.activationMethodFormGroup.patchValue(stepData);
    }
  }

  onSaveStepData() {
    this.warrantyActivationFormService.setStepData('activationMethod', this.activationMethodFormGroup.value)
    this.stepSaved.emit();
  }
}
